/*!
 * 
 *   @creditas/dream-catcher v1.1.2
 *   undefined
 * 
 *   Copyright (c) Octavio Fernandes 
 * 
 *   This source code is licensed under the UNLICENSED license found in the
 *   LICENSE file in the root directory of this source tree.
 * 
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.DreamCatcher = t() : e.DreamCatcher = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      for (var n, r = 0; r < t.length; r++) {
        (n = t[r]).enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    n.r(t), n.d(t, "DreamCatcher", function () {
      return f;
    });
    var i = n(1),
        c = n(2),
        a = n(5).windowGlobal;
    "undefined" == typeof URLSearchParams && n(6);

    var s = {
      SameSite: "Strict",
      domain: ".creditas.com",
      expires: 1,
      path: "/"
    },
        u = ["utm_source", "utm_content", "utm_campaign", "utm_medium", "utm_referrer", "utm_expid", "utm_terms"],
        f = function () {
      function e() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        r(this, e), this._configs = Object.assign(s, t), this._window = a(), this._sessionID = "";
      }

      return function (e, t, n) {
        t && o(e.prototype, t), n && o(e, n);
      }(e, [{
        key: "init",
        value: function value() {
          this.sessionID || (this.sessionID = c()), this.onTagsChange();
        }
      }, {
        key: "getAllSessionCookies",
        value: function value() {
          var e = this,
              t = {};
          return Object.keys(i.get()).forEach(function (n) {
            var r = n.replace("".concat(e.sessionID, "_"), "");
            u.includes(r) && (t[n] = i.get(n));
          }), t;
        }
      }, {
        key: "getFromCookies",
        value: function value(e) {
          return i.get("".concat(this.sessionID, "_").concat(e));
        }
      }, {
        key: "onTagsChange",
        value: function value() {
          var e = this,
              t = new URLSearchParams(this._window.location.search),
              n = {};
          u.forEach(function (r) {
            var o = t.get(r);
            o && e.getFromCookies(r) !== o && (n[r] = t.get(r));
          }), this.setCookies(n);
        }
      }, {
        key: "setCookies",
        value: function value(e) {
          var t = this;
          Object.keys(e).forEach(function (n) {
            i.set("".concat(t.sessionID, "_").concat(n), e[n], t._configs);
          });
        }
      }, {
        key: "flush",
        value: function value() {
          var e = this;
          Object.keys(this.getAllSessionCookies()).forEach(function (t) {
            i.remove(t, e._configs);
          });
        }
      }, {
        key: "getGoogleClientId",
        value: function value() {
          try {
            return this._window.ga.getAll()[0].get("clientId");
          } catch (e) {
            return null;
          }
        }
      }, {
        key: "sessionID",
        set: function set(e) {
          i.set("DCSESSID", e, this._configs), this._sessionID = e;
        },
        get: function get() {
          return this._sessionID ? this._sessionID : i.get("DCSESSID");
        }
      }]), e;
    }();
  }, function (e, t, n) {
    var r, o;
    /*!
     * JavaScript Cookie v2.2.1
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */

    !function (i) {
      if (void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o), !0, e.exports = i(), !!0) {
        var c = window.Cookies,
            a = window.Cookies = i();

        a.noConflict = function () {
          return window.Cookies = c, a;
        };
      }
    }(function () {
      function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            t[r] = n[r];
          }
        }

        return t;
      }

      function t(e) {
        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }

      return function n(r) {
        function o() {}

        function i(t, n, i) {
          if ("undefined" != typeof document) {
            "number" == typeof (i = e({
              path: "/"
            }, o.defaults, i)).expires && (i.expires = new Date(1 * new Date() + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";

            try {
              var c = JSON.stringify(n);
              /^[\{\[]/.test(c) && (n = c);
            } catch (e) {}

            n = r.write ? r.write(n, t) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var a = "";

            for (var s in i) {
              i[s] && (a += "; " + s, !0 !== i[s] && (a += "=" + i[s].split(";")[0]));
            }

            return document.cookie = t + "=" + n + a;
          }
        }

        function c(e, n) {
          if ("undefined" != typeof document) {
            for (var o = {}, i = document.cookie ? document.cookie.split("; ") : [], c = 0; c < i.length; c++) {
              var a = i[c].split("="),
                  s = a.slice(1).join("=");
              n || '"' !== s.charAt(0) || (s = s.slice(1, -1));

              try {
                var u = t(a[0]);
                if (s = (r.read || r)(s, u) || t(s), n) try {
                  s = JSON.parse(s);
                } catch (e) {}
                if (o[u] = s, e === u) break;
              } catch (e) {}
            }

            return e ? o[e] : o;
          }
        }

        return o.set = i, o.get = function (e) {
          return c(e, !1);
        }, o.getJSON = function (e) {
          return c(e, !0);
        }, o.remove = function (t, n) {
          i(t, "", e(n, {
            expires: -1
          }));
        }, o.defaults = {}, o.withConverter = n, o;
      }(function () {});
    });
  }, function (e, t, n) {
    var r,
        o,
        i = n(3),
        c = n(4),
        a = 0,
        s = 0;

    e.exports = function (e, t, n) {
      var u = t && n || 0,
          f = t || [],
          l = (e = e || {}).node || r,
          p = void 0 !== e.clockseq ? e.clockseq : o;

      if (null == l || null == p) {
        var h = i();
        null == l && (l = r = [1 | h[0], h[1], h[2], h[3], h[4], h[5]]), null == p && (p = o = 16383 & (h[6] << 8 | h[7]));
      }

      var d = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
          v = void 0 !== e.nsecs ? e.nsecs : s + 1,
          y = d - a + (v - s) / 1e4;
      if (y < 0 && void 0 === e.clockseq && (p = p + 1 & 16383), (y < 0 || d > a) && void 0 === e.nsecs && (v = 0), v >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      a = d, s = v, o = p;
      var m = (1e4 * (268435455 & (d += 122192928e5)) + v) % 4294967296;
      f[u++] = m >>> 24 & 255, f[u++] = m >>> 16 & 255, f[u++] = m >>> 8 & 255, f[u++] = 255 & m;
      var g = d / 4294967296 * 1e4 & 268435455;
      f[u++] = g >>> 8 & 255, f[u++] = 255 & g, f[u++] = g >>> 24 & 15 | 16, f[u++] = g >>> 16 & 255, f[u++] = p >>> 8 | 128, f[u++] = 255 & p;

      for (var w = 0; w < 6; ++w) {
        f[u + w] = l[w];
      }

      return t || c(f);
    };
  }, function (e, t) {
    var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (n) {
      var r = new Uint8Array(16);

      e.exports = function () {
        return n(r), r;
      };
    } else {
      var o = new Array(16);

      e.exports = function () {
        for (var e, t = 0; t < 16; t++) {
          0 == (3 & t) && (e = 4294967296 * Math.random()), o[t] = e >>> ((3 & t) << 3) & 255;
        }

        return o;
      };
    }
  }, function (e, t) {
    for (var n = [], r = 0; r < 256; ++r) {
      n[r] = (r + 256).toString(16).substr(1);
    }

    e.exports = function (e, t) {
      var r = t || 0,
          o = n;
      return [o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], "-", o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]], o[e[r++]]].join("");
    };
  }, function (e, t, n) {
    "use strict";

    function r() {
      return "undefined" != typeof window && window.location ? window : {
        location: {
          search: ""
        }
      };
    }

    n.r(t), n.d(t, "windowGlobal", function () {
      return r;
    });
  }, function (e, t, n) {
    (function (e) {
      !function (e) {
        "use strict";

        var t,
            n = e.URLSearchParams && e.URLSearchParams.prototype.get ? e.URLSearchParams : null,
            r = n && "a=1" === new n({
          a: 1
        }).toString(),
            o = n && "+" === new n("s=%2B").get("s"),
            i = !n || ((t = new n()).append("s", " &"), "s=+%26" === t.toString()),
            c = f.prototype,
            a = !(!e.Symbol || !e.Symbol.iterator);

        if (!(n && r && o && i)) {
          c.append = function (e, t) {
            v(this.__URLSearchParams__, e, t);
          }, c.delete = function (e) {
            delete this.__URLSearchParams__[e];
          }, c.get = function (e) {
            var t = this.__URLSearchParams__;
            return this.has(e) ? t[e][0] : null;
          }, c.getAll = function (e) {
            var t = this.__URLSearchParams__;
            return this.has(e) ? t[e].slice(0) : [];
          }, c.has = function (e) {
            return m(this.__URLSearchParams__, e);
          }, c.set = function (e, t) {
            this.__URLSearchParams__[e] = ["" + t];
          }, c.toString = function () {
            var e,
                t,
                n,
                r,
                o = this.__URLSearchParams__,
                i = [];

            for (t in o) {
              for (n = l(t), e = 0, r = o[t]; e < r.length; e++) {
                i.push(n + "=" + l(r[e]));
              }
            }

            return i.join("&");
          };
          var s = !!o && n && !r && e.Proxy;
          Object.defineProperty(e, "URLSearchParams", {
            value: s ? new Proxy(n, {
              construct: function construct(e, t) {
                return new e(new f(t[0]).toString());
              }
            }) : f
          });
          var u = e.URLSearchParams.prototype;
          u.polyfill = !0, u.forEach = u.forEach || function (e, t) {
            var n = d(this.toString());
            Object.getOwnPropertyNames(n).forEach(function (r) {
              n[r].forEach(function (n) {
                e.call(t, n, r, this);
              }, this);
            }, this);
          }, u.sort = u.sort || function () {
            var e,
                t,
                n,
                r = d(this.toString()),
                o = [];

            for (e in r) {
              o.push(e);
            }

            for (o.sort(), t = 0; t < o.length; t++) {
              this.delete(o[t]);
            }

            for (t = 0; t < o.length; t++) {
              var i = o[t],
                  c = r[i];

              for (n = 0; n < c.length; n++) {
                this.append(i, c[n]);
              }
            }
          }, u.keys = u.keys || function () {
            var e = [];
            return this.forEach(function (t, n) {
              e.push(n);
            }), h(e);
          }, u.values = u.values || function () {
            var e = [];
            return this.forEach(function (t) {
              e.push(t);
            }), h(e);
          }, u.entries = u.entries || function () {
            var e = [];
            return this.forEach(function (t, n) {
              e.push([n, t]);
            }), h(e);
          }, a && (u[e.Symbol.iterator] = u[e.Symbol.iterator] || u.entries);
        }

        function f(e) {
          ((e = e || "") instanceof URLSearchParams || e instanceof f) && (e = e.toString()), this.__URLSearchParams__ = d(e);
        }

        function l(e) {
          var t = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\0"
          };
          return encodeURIComponent(e).replace(/[!'\(\)~]|%20|%00/g, function (e) {
            return t[e];
          });
        }

        function p(e) {
          return e.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/gi, function (e) {
            return decodeURIComponent(e);
          });
        }

        function h(t) {
          var n = {
            next: function next() {
              var e = t.shift();
              return {
                done: void 0 === e,
                value: e
              };
            }
          };
          return a && (n[e.Symbol.iterator] = function () {
            return n;
          }), n;
        }

        function d(e) {
          var t = {};
          if ("object" == typeof e) {
            if (y(e)) for (var n = 0; n < e.length; n++) {
              var r = e[n];
              if (!y(r) || 2 !== r.length) throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
              v(t, r[0], r[1]);
            } else for (var o in e) {
              e.hasOwnProperty(o) && v(t, o, e[o]);
            }
          } else {
            0 === e.indexOf("?") && (e = e.slice(1));

            for (var i = e.split("&"), c = 0; c < i.length; c++) {
              var a = i[c],
                  s = a.indexOf("=");
              -1 < s ? v(t, p(a.slice(0, s)), p(a.slice(s + 1))) : a && v(t, p(a), "");
            }
          }
          return t;
        }

        function v(e, t, n) {
          var r = "string" == typeof n ? n : null != n && "function" == typeof n.toString ? n.toString() : JSON.stringify(n);
          m(e, t) ? e[t].push(r) : e[t] = [r];
        }

        function y(e) {
          return !!e && "[object Array]" === Object.prototype.toString.call(e);
        }

        function m(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
      }(void 0 !== e ? e : "undefined" != typeof window ? window : this);
    }).call(this, n(7));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }]);
});